import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import AETSetupSearchForm from './../AET/AETSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'AETProgrammeCode', numeric: false, disablePadding: true, label: 'Programme Code' },
    { id: 'AETProgrammeDescription', numeric: false, disablePadding: true, label: 'Programme Description' }
];

const searchParameters = [
    { Name: "AETProgrammeCode", Value: "" },
    { Name: "AETProgrammeDescription", Value: "" }
];

const utils = new ViewUtils();

class AETSetupSearch extends Component {
    constructor(props) {
        super(props)

        this.state = {
            model: {
                AETProgrammeCode: "",
                AETProgrammeDescription: ""
            },
            selectedAETProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add},
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit},
                        { id: "delete", label: '', tooltip: 'Remove AET', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/AETsetup/getsearch"}
                    entityViewPath='/AETsetup'
                    title='AET' 
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="AETProgrammeDescription" mode={this.props.mode}                   
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/AETSetup/RemoveAET"} useDeletePost={true}
                    promptTitle={"Remove AET Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the AET programme is a permanent action and the AET programme will not be available going forward. Are you sure you want to remove this AET programme?"}
                    >
                    <AETSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(AETSetupSearch));

